import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

import './index.css'
import logo from './rapport-logo.svg'

const IndexPage = ({ data }) => (
  <div className="app-landing">
    <div className="hero__screenshot">
      <Img sizes={data.screenshot.childImageSharp.sizes} />
    </div>
    <div className="hero">
      <div className="hero__inner">
        <img src={logo} alt="Rapport Logo" />
        <h2 className="tagline">give focus to your meetings</h2>
        <div className="hero__cta--primary">
          <OutboundLink href="https://rapport-app.leanloop.co.uk" className="btn">
            Start a Meeting
          </OutboundLink>
          <span className="cta-callout">it's free!</span>
        </div>
        <div className="hero__cta--secondary">
          or <a href="#more">learn more</a>
        </div>
      </div>
    </div>
    <div className="about" id="more">
      <div className="about-pane about-pane--flip">
        <div className="about-pane__left about-pane--content">
          <h3 className="about-pane__title">
            great for <span className="em">meetings</span>
          </h3>
          <div className="about-pane__content">
            <p>
              Use Rapport to facilitate any meeting. Rather than spending ages
              talking about one thing and running out of time, keep the meeting
              focused on only the most important items.
            </p>
          </div>
        </div>
        <div className="about-pane__right about-pane--img">
          <Img sizes={data.img2.childImageSharp.sizes} />
        </div>
      </div>
      <div className="about-pane about-pane--flip">
        <div className="about-pane__left about-pane--img">
          <Img sizes={data.img3.childImageSharp.sizes} />
        </div>
        <div className="about-pane__right about-pane--content">
          <h3 className="about-pane__title">
            perfect for your agile <span className="em">retrospective</span>
          </h3>
          <div className="about-pane__content">
            <p>
              We made Rapport with Agile teams in mind. We should know, we've
              worked with lots! Our vision was to make the perfect tool for a
              fun retrospective for any agile team.
            </p>
          </div>
        </div>
      </div>
      <div className="about-pane about-pane">
        <div className="about-pane__left about-pane--content">
          <h3 className="about-pane__title">
            co-located or <br />distributed <span className="em">teams</span>
          </h3>
          <div className="about-pane__content">
            <p>
              We know that meetings and retrospectives are a challenge when you
              have distributed teams. That's why Rapport is made with that in
              mind. Either use the tool while on a Slack or Skype call, or if
              you're all in the same room, just have it on the main screen.
            </p>
          </div>
        </div>
        <div className="about-pane__right about-pane--img">
          <Img sizes={data.img1.childImageSharp.sizes} />
        </div>
      </div>
    </div>
  </div>
)

export default IndexPage

export const query = graphql`
  fragment sizes on File {
    childImageSharp {
      sizes(maxWidth: 1200) {
        aspectRatio
        src
        srcSet
        srcWebp
        srcSetWebp
        sizes
        originalImg
        originalName
      }
    }
  }
  query imgQuery {
    img1: file(relativePath: { eq: "img/img1.png" }) {
      ...sizes
    }
    img2: file(relativePath: { eq: "img/img2.png" }) {
      ...sizes
    }
    img3: file(relativePath: { eq: "img/img3.png" }) {
      ...sizes
    }
    screenshot: file(relativePath: { eq: "img/screenshot.png" }) {
      childImageSharp {
        sizes(maxWidth: 1628) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js